var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMovoraArrow = function SvgMovoraArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Directional chevron")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.579 17.964-3.79-3.647A3.2 3.2 0 0 1 7.793 12a3.2 3.2 0 0 1 .996-2.317l3.79-3.647a.13.13 0 0 1 .18 0l1.208 1.162a.105.105 0 0 1 0 .153l-3.981 3.831-.045.05c-.22.212-.331.49-.332.768 0 .278.111.556.332.768l.03.035 3.996 3.846a.105.105 0 0 1 0 .153l-1.208 1.162a.13.13 0 0 1-.18 0"
  })));
};
export default SvgMovoraArrow;